// extracted by mini-css-extract-plugin
export default {"callClientLiveBox":"index_callClientLiveBox_oLfwr","callClientLive":"index_callClientLive_0bhT0"};